import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from './axiosBaseQuery';

const origin = window.location.origin;
const isLocalhost =
  origin.includes('localhost') ||
  origin.includes('127.0. 0.1');

export const emptySplitApi = createApi({
  baseQuery: axiosBaseQuery({
    baseUrl:
      process.env.REACT_APP_API_BASE_URL ||
      'https://retail.nurture.farm/api/',
  }),
  endpoints: () => ({}),
});

export const graphQLEmptySplitApi = createApi({
  reducerPath: 'graphQlApi',
  baseQuery: axiosBaseQuery({
    baseUrl: (isLocalhost
      ? process.env.REACT_APP_API_LOAD_BALANCER
      : process.env.REACT_APP_API_GRAPHQL_BASE_URL)!,
  }),
  endpoints: () => ({}),
});
